import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { mapChannelMembers } from '../../../utils/multipleeditors'

export default class MultipleEditors extends Component {
  constructor(props) {
    super(props)
    this.state = {
      editors: mapChannelMembers(props.channel.members.members)
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.newEditors !== this.props.newEditors) {
      let newEditorsState = this.state.editors.concat(nextProps.newEditors)
      newEditorsState = newEditorsState.filter(
        (editor, index, self) =>
          index === self.findIndex(e => e.id === editor.id)
      )
      this.setState(prevState => ({
        editors: newEditorsState
      }))
    }
  }

  render() {
    return (
      <div className="multiple-editors-info">
        <div className="edit-warning-icon" />
        <div className="multiple-editors-message">
          {this.state.editors.length === 1 ? (
            <span>
              <strong>{this.state.editors[0].name}</strong> is{' '}
            </span>
          ) : (
            <span>
              {this.state.editors.map((m, i) => {
                const length = this.state.editors.length
                if (length > 2 && i < length - 1) {
                  return (
                    <span>
                      <strong>{m.name}</strong>,{' '}
                    </span>
                  )
                } else if (length === 2 && i < length - 1) {
                  return (
                    <span>
                      <strong>{m.name}</strong>{' '}
                    </span>
                  )
                } else {
                  return (
                    <span>
                      and <strong>{m.name}</strong> are{' '}
                    </span>
                  )
                }
              })}
            </span>
          )}
          <span>
            currently editing this page. Your changes or their changes could be
            lost. Tap “Cancel” to stop editing.
          </span>
        </div>
      </div>
    )
  }
}

MultipleEditors.propTypes = {
  channel: PropTypes.object.isRequired,
  newEditors: PropTypes.array.isRequired
}



// WEBPACK FOOTER //
// ./src/components/quest/multipleeditors/MultipleEditorsInfo.js